/**
 * Keep the reader where they were across a live update.
 *
 * A window scroll offset is meaningless once a block above the viewport changes
 * height, so anchor to the first block still on screen and put that block back
 * where it was afterwards. Ported unchanged from app.js. TASK-034.
 */

export interface ScrollAnchor {
  id: string
  top: number
}

export function captureScroll(container: HTMLElement | null | undefined): ScrollAnchor | null {
  if (!container) return null
  for (const child of Array.from(container.children)) {
    const id = child.getAttribute('data-id')
    if (!id) continue
    const box = child.getBoundingClientRect()
    if (box.bottom > 0) return { id, top: box.top }
  }
  return null
}

export function restoreScroll(
  container: HTMLElement | null | undefined,
  anchor: ScrollAnchor | null,
): void {
  if (!container || !anchor || !anchor.id) return
  if (!(window.CSS && CSS.escape)) return
  const block = container.querySelector(`[data-id="${CSS.escape(anchor.id)}"]`)
  if (!block) return
  const delta = block.getBoundingClientRect().top - anchor.top
  if (Math.abs(delta) >= 1) window.scrollBy(0, delta)
}
